export const APPROVED_ADS_WARNING_MESSAGE =
  'VAST cannot be changed for creative assigned to approved ad(s). Please create a new creative.';

export const VERIFIED_CREATIVE_WARNING_MESSAGE =
  'Cannot modify VAST URL on verified Creative. Creative is verified for Ad ID';

export const DEFAULT_TAG_INPUT_LENGTH = 80;
